import { render, staticRenderFns } from "./c-homepage.vue?vue&type=template&id=86e28382&scoped=true&"
import script from "./c-homepage.vue?vue&type=script&lang=js&"
export * from "./c-homepage.vue?vue&type=script&lang=js&"
import style0 from "./c-homepage.vue?vue&type=style&index=0&id=86e28382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e28382",
  null
  
)

export default component.exports